import React from 'react';
import { useDispatch } from 'react-redux';

import { Dialog } from '@ezugi/primitives';

import { useIntl } from '../../../hooks/useIntl';
import { dialogActions, notificationActions, videoActions } from '../../../store/actions';
import { refreshButton, continueButton } from './buttons';

const { dialog } = dialogActions;
const { notification } = notificationActions;
const { video } = videoActions;

export const videoErrorIntlKeys = {
  title: 'messages.video_unavailable_title',
  message: 'messages.video_unavailable_continue_message',
  continueLabel: 'general.continue',
  refreshLabel: 'general.refresh',
};

const VideoError = (props) => {
  const { title, message, continueLabel, refreshLabel } = useIntl({
    keys: videoErrorIntlKeys,
  });

  const dispatch = useDispatch();

  const removeDialog = () => dispatch(dialog.remove());
  const reconnectVideo = () => dispatch(video.reconnect());
  const addNotification = (notificationData) => dispatch(notification.add(notificationData));

  return (
    <Dialog
      {...props}
      on={true}
    >
      <Dialog.Wrapper>
        <Dialog.Title>
          {title}
        </Dialog.Title>
        <Dialog.Description dangerouslySetInnerHTML={{ __html: message }} />
        <Dialog.Buttons>
          <Dialog.Button
            {...continueButton}
            label={continueLabel}
            onClick={() => {
              addNotification({
                message: 'notifications.video_unavailable',
                delay: 99999999,
                trigger: `${video.error.type}`,
              });
              reconnectVideo();
              removeDialog();
            }}
          />
          <Dialog.Button
            {...refreshButton}
            label={refreshLabel}
            onClick={() => location.reload()}
          />
        </Dialog.Buttons>
      </Dialog.Wrapper>
    </Dialog>
  );
};

export default VideoError;
